module.exports = __webpack_public_path__ + "static/footer-09b19630b556181d50668612d79da139.svg";